import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import { generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

const BlogPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  // Generate structured data
  const structuredData = [
    generateWebPageSchema(
      'ブログ・新着情報｜おかやま放課後等デイサービス｜岡山市の療育情報',
      '岡山市の放課後等デイサービス「おかやま放課後等デイサービス」のブログ・新着情報。日々の活動の様子や最新のお知らせ、療育に関する情報をお届けします。',
      '/blog'
    ),
    generateBreadcrumbSchema([
      { name: 'ホーム', url: '/' },
      { name: 'ブログ・新着情報', url: '/blog' }
    ])
  ];

  const blogPosts = [
    {
      id: 1,
      title: '新年度のご挨拶と新しい取り組みについて',
      date: '2024年4月1日',
      category: 'お知らせ',
      excerpt: '新年度を迎え、新しいスタッフの紹介と今年度の新しい療育プログラムについてお知らせいたします。',
      image: 'https://public.readdy.ai/ai/img_res/af356fa90a845f86eabfe10a7ee3814a.jpg',
      content: '新年度を迎え、おかやま放課後等デイサービスでは新しいスタッフを迎え、より充実したサービスを提供してまいります。今年度は感覚統合療法の専門プログラムを新たに導入し、お子様一人ひとりの発達段階に応じたより細やかな支援を行います。'
    },
    {
      id: 2,
      title: '春の遠足イベントを開催しました',
      date: '2024年3月25日',
      category: 'イベント',
      excerpt: '岡山後楽園での春の遠足イベントの様子をご報告いたします。お子様たちの笑顔あふれる一日となりました。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20children%20enjoying%20outdoor%20activities%20in%20beautiful%20park%2C%20spring%20season%2C%20cherry%20blossoms%2C%20happy%20expressions%2C%20group%20activities%2C%20natural%20lighting%2C%20joyful%20atmosphere&width=400&height=250&seq=blog2&orientation=landscape',
      content: '3月25日に岡山後楽園にて春の遠足を開催いたしました。お天気にも恵まれ、お子様たちは桜の下でお弁当を食べたり、園内を散策したりと、とても楽しい時間を過ごしました。普段とは違う環境での活動を通じて、新しい発見や成長を感じることができました。'
    },
    {
      id: 3,
      title: '保護者向け勉強会「発達支援の基礎知識」開催報告',
      date: '2024年3月15日',
      category: '勉強会',
      excerpt: '保護者様を対象とした発達支援に関する勉強会を開催し、多くの方にご参加いただきました。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20parents%20attending%20educational%20seminar%2C%20conference%20room%20setting%2C%20professional%20presentation%2C%20attentive%20audience%2C%20learning%20atmosphere%2C%20modern%20interior%20natural%20lighting&width=400&height=250&seq=blog3&orientation=landscape',
      content: '3月15日に保護者様向けの勉強会を開催いたしました。「家庭でできる発達支援」をテーマに、日常生活での関わり方や声かけのポイントについてお話しさせていただきました。参加された保護者様からは「具体的でわかりやすかった」「すぐに実践できる内容だった」とのお声をいただきました。'
    },
    {
      id: 4,
      title: '新しい療育教材を導入しました',
      date: '2024年3月1日',
      category: 'サービス向上',
      excerpt: 'お子様の発達段階に応じた新しい療育教材を導入し、より効果的な支援を提供できるようになりました。',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20educational%20therapy%20materials%20and%20toys%2C%20modern%20learning%20tools%2C%20bright%20therapy%20room%2C%20organized%20display%2C%20professional%20equipment%2C%20natural%20lighting%2C%20child-friendly%20environment&width=400&height=250&seq=blog4&orientation=landscape',
      content: '3月より新しい療育教材を導入いたしました。感覚統合を促進する教材や、コミュニケーション能力向上のためのツールなど、最新の研究に基づいた効果的な教材を取り入れています。お子様たちも新しい教材に興味を示し、より積極的に活動に参加してくれています。'
    },
    {
      id: 5,
      title: '冬休み特別プログラムの実施報告',
      date: '2024年1月15日',
      category: 'イベント',
      excerpt: '冬休み期間中に実施した特別プログラムの様子をご報告いたします。お子様たちの創作活動の成果もご紹介します。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20children%20engaged%20in%20winter%20craft%20activities%2C%20creative%20arts%20and%20crafts%2C%20colorful%20materials%2C%20warm%20indoor%20environment%2C%20happy%20expressions%2C%20natural%20lighting%2C%20festive%20atmosphere&width=400&height=250&seq=blog5&orientation=landscape',
      content: '冬休み期間中は通常とは異なる特別プログラムを実施いたしました。お正月の伝統的な遊びや冬の工作活動など、季節感を大切にした内容で、お子様たちは楽しみながら様々なことを学びました。作品展示会も開催し、保護者様にもお子様の成長をご覧いただくことができました。'
    },
    {
      id: 6,
      title: 'スタッフ研修「最新の療育手法について」実施',
      date: '2024年1月10日',
      category: 'スタッフ研修',
      excerpt: 'より質の高いサービス提供のため、スタッフ向けの専門研修を実施いたしました。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20professional%20staff%20attending%20training%20session%2C%20conference%20room%2C%20educational%20materials%2C%20focused%20learning%2C%20professional%20development%2C%20modern%20office%20setting%2C%20natural%20lighting&width=400&height=250&seq=blog6&orientation=landscape',
      content: '1月10日にスタッフ向けの専門研修を実施いたしました。外部講師をお招きし、最新の療育手法や支援技術について学びました。研修で得た知識を日々の支援に活かし、お子様により良いサービスを提供できるよう努めてまいります。'
    }
  ];

  const categories = [
    'すべて',
    'お知らせ',
    'イベント',
    '勉強会',
    'サービス向上',
    'スタッフ研修'
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="ブログ・新着情報｜おかやま放課後等デイサービス｜岡山市の療育情報"
        description="岡山市の放課後等デイサービス「おかやま放課後等デイサービス」のブログ・新着情報。日々の活動の様子や最新のお知らせ、療育に関する情報をお届けします。"
        keywords="岡山市,放課後等デイサービス,ブログ,新着情報,療育,発達支援,イベント"
        canonicalUrl={`${siteUrl}/blog`}
        structuredData={structuredData}
      />
      
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 md:py-24 bg-gradient-to-br from-orange-600 to-red-600">
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 md:mb-8">
            <strong>ブログ・新着情報</strong>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white max-w-3xl mx-auto leading-relaxed">
            日々の活動の様子や最新のお知らせをお届けします。お子様たちの成長の記録をぜひご覧ください。
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 md:py-10 bg-gradient-to-r from-orange-50 to-red-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-4 md:px-6 py-2 md:py-3 text-sm md:text-base rounded-full font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  index === 0
                    ? 'bg-orange-600 text-white shadow-lg hover:shadow-xl'
                    : 'bg-white text-gray-700 hover:bg-orange-100 shadow-md hover:shadow-lg'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
              >
                <div className="w-full h-48 sm:h-56">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 md:p-8">
                  <div className="flex items-center justify-between mb-3 md:mb-4 gap-2">
                    <span className="inline-block bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-xs md:text-sm font-semibold whitespace-nowrap shadow-sm">
                      {post.category}
                    </span>
                    <time className="text-xs md:text-sm text-gray-500 whitespace-nowrap">{post.date}</time>
                  </div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-3 md:mb-4 line-clamp-2 break-words">
                    {post.title}
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed mb-4 md:mb-6 line-clamp-3 break-words">
                    {post.excerpt}
                  </p>
                  <button className="text-sm md:text-base text-orange-600 hover:text-orange-700 font-medium transition-colors cursor-pointer">
                    続きを読む <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-orange-50 to-red-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 md:mb-6">
              <strong>注目記事</strong>
            </h2>
          </div>

          <div className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
            <div className="md:flex">
              <div className="md:w-1/2">
                <img
                  src={blogPosts[0]?.image}
                  alt={blogPosts[0]?.title}
                  className="w-full h-56 sm:h-64 md:h-full object-cover"
                />
              </div>
              <div className="md:w-1/2 p-6 md:p-10">
                <div className="flex flex-wrap items-center gap-3 mb-4 md:mb-6">
                  <span className="inline-block bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm md:text-base font-semibold whitespace-nowrap shadow-sm">
                    {blogPosts[0]?.category}
                  </span>
                  <time className="text-sm md:text-base text-gray-500 whitespace-nowrap">
                    {blogPosts[0]?.date}
                  </time>
                </div>
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4 md:mb-6 break-words">
                  {blogPosts[0]?.title}
                </h3>
                <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed mb-6 md:mb-8 break-words">
                  {blogPosts[0]?.content}
                </p>
                <button className="bg-orange-600 text-white px-6 md:px-8 py-3 md:py-4 text-base md:text-lg rounded-lg hover:bg-orange-700 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl">
                  詳細を見る
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-xl shadow-xl p-8 md:p-10 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6">
              最新情報をお届けします
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white mb-6 md:mb-8">
              イベント情報や療育に関する最新情報をメールでお届けします。
            </p>
            <form 
              action="https://readdy.ai/api/form/d4ogdu6r62ainp8kdan0" 
              method="POST" 
              data-readdy-form
              id="newsletter-form"
              className="max-w-md mx-auto"
            >
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="メールアドレスを入力"
                  className="flex-1 px-4 md:px-5 py-3 md:py-4 text-base md:text-lg rounded-lg border-0 text-gray-800 placeholder-gray-500 focus:ring-2 focus:ring-white transition-all"
                />
                <button 
                  type="submit"
                  className="bg-white text-orange-600 px-6 md:px-8 py-3 md:py-4 text-base md:text-lg rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
                >
                  登録する
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Archive */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-orange-50 to-red-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 md:mb-6">
              <strong>アーカイブ</strong>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all duration-300">
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-4 md:mb-6">
                <i className="ri-calendar-line mr-2 text-orange-600"></i>
                月別アーカイブ
              </h3>
              <ul className="space-y-3">
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    2024年4月 (2)
                  </a>
                </li>
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    2024年3月 (3)
                  </a>
                </li>
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    2024年2月 (2)
                  </a>
                </li>
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    2024年1月 (4)
                  </a>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all duration-300">
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-4 md:mb-6">
                <i className="ri-tag-line mr-2 text-orange-600"></i>
                カテゴリー
              </h3>
              <ul className="space-y-3">
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    お知らせ (3)
                  </a>
                </li>
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    イベント (4)
                  </a>
                </li>
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    勉強会 (2)
                  </a>
                </li>
                <li>
                  <a href="#" className="text-base sm:text-lg md:text-xl text-gray-600 hover:text-orange-600 cursor-pointer transition-colors">
                    スタッフ研修 (2)
                  </a>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all duration-300">
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-4 md:mb-6">
                <i className="ri-star-line mr-2 text-orange-600"></i>
                人気記事
              </h3>
              <ul className="space-y-3">
                <li>
                  <a href="#" className="text-sm sm:text-base md:text-lg text-gray-600 hover:text-orange-600 cursor-pointer break-words transition-colors">
                    保護者向け勉強会「発達支援の基礎知識」開催報告
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm sm:text-base md:text-lg text-gray-600 hover:text-orange-600 cursor-pointer break-words transition-colors">
                    春の遠足イベントを開催しました
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm sm:text-base md:text-lg text-gray-600 hover:text-orange-600 cursor-pointer break-words transition-colors">
                    新しい療育教材を導入しました
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
